import React, { useContext } from 'react';
import classnames from 'classnames';
import { ConfigContext } from 'src/components/AppShell/ConfigProvider';
import { Svg } from 'src/components/Svg/Svg';

import classes from './HeaderControls.scss';

export const HeaderCallUs = ({ whiteIcons }: { whiteIcons: boolean }) => {
    const { furniture } = useContext(ConfigContext);

    if (!furniture.headerPhoneNumber) return null;

    return (
        <a
            href={`tel:${furniture.headerPhoneNumber}`}
            className={classnames(classes.headerControl, classes.headerControlContact)}
        >
            <Svg
                className={classnames('phoneIcon', { [classes.phoneIconWhite]: whiteIcons })}
                name="phone-header"
                color="white"
            />
            <span className={classes.headerControlContent}>
                <small>Call us free on</small>
                {furniture.headerPhoneNumber}
            </span>
        </a>
    );
};
